import { Router } from "@angular/router";
import { AngularFirestore, AngularFirestoreDocument } from "@angular/fire/firestore";
import { Injectable } from "@angular/core";
import { AngularFireAuth } from "@angular/fire/auth";
import { User } from './User';

@Injectable({
    providedIn: "root"
})
export class AuthService {
    userData: any; // Save logged in user data
    constructor(
        private firebaseAuth: AngularFireAuth,
        private afs: AngularFirestore,
        private router: Router
    ) { /* Saving user data in localstorage when 
  logged in and setting up null when logged out */
        this.firebaseAuth.authState.subscribe(user => {
            if (user) {
                this.userData = user;
                localStorage.setItem('user', JSON.stringify(this.userData));
                JSON.parse(localStorage.getItem('user'));
            } else {
                localStorage.setItem('user', null);
                JSON.parse(localStorage.getItem('user'));
            }
        })
    }

    public async login(
        email: string,
        password: string
    ): Promise<{ error?: string }> {
        const userCredentials = await this.firebaseAuth.auth.signInWithEmailAndPassword(
            email,
            password
        );
        const user = userCredentials.user;
        this.SetUserData(user);
        return {};
    }

    public get isAuthenticated(): boolean {
        const user = JSON.parse(localStorage.getItem("user"));
        return user !== null && user.emailVerified !== false ? true : false;
    }

    public logout() {
        return this.firebaseAuth.auth.signOut().then(() => {
            localStorage.removeItem('user');
            this.router.navigate(["login"]);
        });
    }

    /* Setting up user data when sign in with username/password, 
  sign up with username/password and sign in with social auth  
  provider in Firestore database using AngularFirestore + AngularFirestoreDocument service */
    SetUserData(user) {
        const userRef: AngularFirestoreDocument<any> = this.afs.doc(`users/${user.uid}`);
        const userData: User = {
            uid: user.uid,
            email: user.email,
            displayName: user.displayName,
            photoURL: user.photoURL,
            emailVerified: user.emailVerified
        }
        return userRef.set(userData, {
            merge: true
        })
    }
}
